import { forwardRef, useState } from 'react';
import type { InputHTMLAttributes } from 'react';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'className'> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid = false, style, onFocus, onBlur, ...rest },
  ref,
) {
  const [focused, setFocused] = useState(false);

  const borderColor = invalid ? 'var(--error)' : focused ? 'var(--accent)' : 'var(--border)';

  return (
    <input
      {...rest}
      ref={ref}
      aria-invalid={invalid || undefined}
      onFocus={(e) => {
        setFocused(true);
        onFocus?.(e);
      }}
      onBlur={(e) => {
        setFocused(false);
        onBlur?.(e);
      }}
      style={{
        width: '100%',
        minHeight: 44,
        padding: '0 var(--sp-4)',
        background: 'var(--surface)',
        border: `1px solid ${borderColor}`,
        borderRadius: 'var(--r-md)',
        color: 'var(--text)',
        fontSize: 'var(--fs-body-lg)',
        // 16px+ on mobile stops iOS Safari zooming the viewport on focus.
        outline: 'none',
        boxShadow: focused && !invalid ? 'var(--shadow-focus)' : 'none',
        transition: 'border-color 120ms ease, box-shadow 120ms ease',
        ...style,
      }}
    />
  );
});
